export default "__VITE_ASSET__DlRGzmUN__"